<template>
  <div>
    <el-popover
      popper-class="integrated-query-popper"
      placement="bottom"
      trigger="click"
      v-model="Show"
    >
      <el-button slot="reference" size="small" type="primary">综合查询</el-button>
      <div class="query-body">
        <div class="query-main">
          <div class="main-list">
            <div class="list-label">厂商编号</div>
            <div class="list-item">
              <el-input size="small" v-model="query.number"></el-input>
            </div>
          </div>
          <div class="main-list">
            <div class="list-label">旧厂商编号</div>
            <div class="list-item">
              <el-input size="small" v-model="query.old_number"></el-input>
            </div>
          </div>
          <div class="main-list">
            <div class="list-label">厂商简称</div>
            <div class="list-item">
              <el-input size="small" v-model="query.sort_name"></el-input>
            </div>
          </div>
          <div class="main-list">
            <div class="list-label">厂商名称</div>
            <div class="list-item">
              <el-input size="small" v-model="query.name"></el-input>
            </div>
          </div>
          <div class="main-list">
            <div class="list-label">所在地区</div>
            <div class="list-item">
              <el-cascader
                style="width: 100%;"
                v-model="query.area"
                @change="changeArea"
                size="small"
                :options="area"
                :props="{ checkStrictly: true, value: 'id', label: 'name' }"
                clearable
              ></el-cascader>
            </div>
          </div>
          <div class="main-list" style="width: 66.66%">
            <div class="list-label">详细地址</div>
            <div class="list-item" style="width: 100%">
              <el-input size="small" v-model="query.address"></el-input>
            </div>
          </div>
          <div class="main-list">
            <div class="list-label">业务范围</div>
            <div class="list-item">
              <el-input size="small" v-model="query.scope_business"></el-input>
            </div>
          </div>
          <div class="main-list">
            <div class="list-label">开发时间</div>
            <div class="list-item">
              <el-date-picker
                v-model="query.development_time"
                :unlink-panels="true"
                type="daterange"
                :default-time="[null, '23:59:59']"
                value-format="yyyy-MM-dd H:m:s"
                size="mini"
              ></el-date-picker>
            </div>
          </div>
          <div class="main-list">
            <div class="list-label">开发人员</div>
            <div class="list-item">
              <el-input size="small" v-model="query.developer_people"></el-input>
            </div>
          </div>
          <div class="main-list">
            <div class="list-label">实际年产值(万人民币)</div>
            <div class="list-item">
              <el-input size="small" v-model="query.output_value"></el-input>
            </div>
          </div>
          <div class="main-list">
            <div class="list-label">工厂面积</div>
            <div class="list-item">
              <el-input size="small" v-model="query.measure"></el-input>
            </div>
          </div>
          <div class="main-list">
            <div class="list-label">工厂商标</div>
            <div class="list-item">
              <el-input size="small" v-model="query.trademark"></el-input>
            </div>
          </div>
          <div class="main-list">
            <div class="list-label">更新日期</div>
            <div class="list-item">
              <el-date-picker
                v-model="query.modify_time"
                :unlink-panels="true"
                type="daterange"
                :default-time="[null, '23:59:59']"
                value-format="yyyy-MM-dd H:m:s"
                size="mini"
              ></el-date-picker>
            </div>
          </div>
          <div class="main-list">
            <div class="list-label">录入人员</div>
            <div class="list-item">
              <el-input size="small" v-model="query.create_user"></el-input>
            </div>
          </div>
          <div class="main-list">
            <div class="list-item" style="padding: 0 15px;">
              <el-checkbox v-model="query.is_main_supplier" style="margin-right: 10px;">核心供应商</el-checkbox>
              <el-checkbox v-model="query.is_cooperation">是否已合作</el-checkbox>
            </div>
          </div>
        </div>
        <div class="query-footer">
          <div class="query-vague">
            <el-checkbox v-model="query.vague">模糊查询</el-checkbox>
          </div>
          <div class="footer-confirm" @click="confirm">确定</div>
          <div
            class="footer-reset"
            @click="query = {area: {}, vague: true, is_cooperation: false, is_main_supplier: false}"
          >重置</div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Show: false,
      query: {
        area: {},
        vague: true
      }
    };
  },
  props: {
    area: {
      default: () => {},
      value: Object
    }
  },
  methods: {
    confirm() {
      this.Show = false;
      if (typeof this.query.area[1] != "undefined") {
        this.query.province_id = this.query.area[0];
        this.query.city_id = this.query.area[1];
      } else if (typeof this.query.area[0] != "undefined") {
        this.query.province_id = this.query.area[0];
      }
      this.$emit("confirm", this.query);
    },
    changeArea(v) {
      this.query.area = v;
    }
  }
};
</script>

<style lang="scss">
.integrated-query-popper {
  .el-date-editor--daterange.el-input__inner {
    width: auto;
  }
  .el-input-number--small {
    width: auto;
    .el-input__inner {
      text-align: left;
    }
  }
  .el-input-number--mini {
    width: auto;
    .el-input__inner {
      text-align: left;
    }
  }
  .el-textarea__inner,
  .el-input__inner {
    padding: 0 6px !important;
    resize: none;
  }
  width: 850px !important;
  .query-body {
    .query-main {
      padding: 10px 0;
      display: flex;
      flex-wrap: wrap;
      .main-list {
        display: flex;
        align-items: center;
        width: 33.33%;
        height: 40px;
        .list-label {
          padding: 0 10px;
          width: 70px;
          flex: 0 0 auto;
        }
        .list-item {
          width: 100%;
        }
      }
    }
    .query-footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      border-top: 1px solid #f0f0f0;
      padding-top: 10px;
      .query-vague {
        margin-right: 14px;
      }
      .footer-confirm,
      .footer-reset {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 6px;
        font-size: 12px;
        color: #fff;
        width: 40px;
        line-height: 1.8;
        background: #2d8cf0;
        border-radius: 3px;
        text-align: center;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.integrated-query {
  padding: 0 10px;
  .integrated-query-popper {
    .query-body {
      padding: 8px 16px;
    }
  }
}
</style>